import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import config from 'client/shared/config';

import ItemOptionsButton from './item-options-button';
import SubscriptionModal from '../artist/subscribe-modal';

@inject('songsStore', 'artistStore', 'userStore', 'apiStore')
@observer
class ItemOptions extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false};
		this.subModalRef = React.createRef();
		window.addEventListener('click', (evt) => {
			this.setState({active: false});
		})
	}
    render () {
		const { song, userStore, optionsTheme = 'light', rollover='true'} = this.props;
		const user = userStore.getLoggedInUser();
		const isFav = user.isHiFived(song.id);
		const subscription = user.getSubscription(song.artistID);


		return (
			<div style={{position:"relative"}}>
			<ItemOptionsButton
                id="ITEMSOPTIONBUTTON"
				menuOnLeft
				onClick={ this.onClick }
				onBlur={this.onBlur}
				className={ `list-options newreleases active left ${ optionsTheme }` }
			>
			</ItemOptionsButton>
                {(this.state.active || this.subModalRef.current?.getModalState() ) && this.renderOptions(isFav, _.isEmpty(subscription))}
			</div>
		);
    }

    renderOptions (favoriteFlag, needsToSubscribe) {
		return (
			<div style={{position: 'absolute', width: '10vw', zIndex: 10}}>
				<div className="cell auto list-options-menu popup-menu" style={
					{
						textAlign: 'left',
						width: '13.4vw',
						display: 'block',
						position: 'absolute',
						left: '-14vw',
						top: '-1.3																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																								vh',
					}
				}>
				{
					!needsToSubscribe &&
						this.renderOptionsButton({
							icon: 'fal fa																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																		arrow-to-bottom',
							label: 'Download Song',
							ariaLabel: "download",
							onClick: this.onDownloadClick
						})
				}
				{
					needsToSubscribe && (<SubscriptionModal ref={this.subModalRef} menuMode={true} artist={ this.props.artist } />)
				}
				{/* {
					this.renderOptionsButton({
						icon: 'fas fa-plus',
						label: 'Add to Playlist',
						// onClick: this.onDownloadClick
					})
				} */}
				{	!favoriteFlag &&
					this.renderOptionsButton({
						icon: 'fas fa-heart',
						label: 'Add to My Favorites',
						ariaLabel: 'favorite',
						onClick: this.onHiFiveClick
					})
				}
				{	favoriteFlag &&
					this.renderOptionsButton({
						icon: 'fas fa-heart-broken',
						label: 'Remove from My Favorites',
						ariaLabel: 'unfavorite',
						onClick: this.onRemoveHiFiveClick
					})
				}
				{/* {
					this.renderOptionsButton({
						icon: 'fas fa-share-alt',
						label: 'Share',
						// onClick: this.onDownloadClick
					})
				} */}
			</div>
			</div>
		);
	}

	@autobind
	renderOptionsButton ({ icon, position, onClick, label, ariaLabel,  attrs = {} }) {
		return (
			<div key={ position }>
				<button
					aria-label={ariaLabel}
					{ ...attrs }
					onClick={ onClick }
					className="button tertiary clear margin-bottom-0"
				>
						<span className={ `${icon} icon` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		this.setState({active: true});
		evt.stopPropagation();
	}

	@autobind
	onBlur (evt) {
		if(!_.isEmpty(evt.relatedTarget)) {
			switch(evt.relatedTarget.ariaLabel) {
				case 'download':
					this.onDownloadClick();
					break;
				case 'playlist':
					break;
				case 'favorite':
					this.onHiFiveClick();
					break;
				case 'subscribe': 
					this.subModalRef.current.handleOpenModal();
					break;
				case 'unfavorite':
					this.onRemoveHiFiveClick();
					break;
				case null:
					this.setState({active: false});
					break;
			}
			evt.stopPropagation();
			if(this.subModalRef.current.getModalState()) {
				this.setState({active: false});
			}
		}
	}

	@autobind
	async onHiFiveClick () {
		const { song, userStore } = this.props;
		const user = userStore.getLoggedInUser();
		const hiFiveData = await song.hiFive(user.id);
		user.hiFived.push(hiFiveData);
		// evt.stopPropagation();

	}

	@autobind
	onRemoveHiFiveClick () {
		const { song, userStore, apiStore } = this.props;
		const user = userStore.getLoggedInUser();
		const { id } = _(user.hiFived).filter({ itemID: song.id }).first();
		const route = `${config.getRoute('hiFive')}/${id}`;
		apiStore.delete({ route });
		user.hiFived = _.remove(user.hiFived.slice(), { id });
		// evt.stopPropagation();
	}

	@autobind
	onDownloadClick () {
		window.location.href = this.props.downloadFilePath;
		this.clearActiveSong();
    }

    clearActiveSong () {
		this.props.songsStore.activeSongRowID = null;
	}
}
export default ItemOptions;
